import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const SEND_REMITTANCE_FOR_APPROVAL = gql`
  ${DEDUCTION_FRAGMENT}
  mutation SendRemittanceForApproval($params: SendRemittanceApprovalParams!) {
    sendRemittanceForApproval(params: $params) {
      ...DeductionFields
    }
  }
`;

export default SEND_REMITTANCE_FOR_APPROVAL;
